(() => {
  'use strict';
  const content = document.querySelector('.page__content');
  if (!content || content.dataset.monolithAccessible) return;
  const lines = [];
  let line = document.createDocumentFragment();
  const flush = () => {
    if (line.textContent.trim()) lines.push(line);
    line = document.createDocumentFragment();
  };
  const flatten = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      line.append(node.cloneNode(true));
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (['META', 'SCRIPT', 'STYLE'].includes(node.tagName)) return;
    if (node.tagName === 'BR') { flush(); return; }
    if (node.tagName === 'A') { line.append(node.cloneNode(true)); return; }
    const block = ['P', 'DIV', 'H2', 'H3', 'LI'].includes(node.tagName);
    if (block) flush();
    [...node.childNodes].forEach(flatten);
    if (block) flush();
  };
  [...content.childNodes].forEach(flatten);
  flush();
  const headingPattern = /^\s*\*\*([^*]+)\*\*\s*$/;
  if (!lines.some(fragment => headingPattern.test(fragment.textContent))) return;
  const originalLinks = [...content.querySelectorAll('a')].map(a => a.href);
  const normalize = text => text.replace(/[\s*:\-]/g, '');
  const originalText = normalize(content.textContent);
  const root = document.createElement('div');
  root.className = 'mba';
  const intro = document.createElement('div');
  intro.className = 'mba__intro';
  const layout = document.createElement('div');
  layout.className = 'mba__layout';
  const nav = document.createElement('nav');
  nav.className = 'mba__nav';
  nav.setAttribute('aria-label', document.querySelector('h1')?.textContent.trim() || '');
  const navList = document.createElement('ol');
  nav.append(navList);
  const sections = document.createElement('div');
  sections.className = 'mba__sections';
  let target = intro;
  let currentList = null;
  let parentItem = null;
  let nestedList = null;
  let count = 0;
  lines.forEach(fragment => {
    const text = fragment.textContent;
    const heading = text.match(headingPattern);
    if (heading) {
      const section = document.createElement('section');
      section.className = 'mba__section';
      const h2 = document.createElement('h2');
      h2.id = `mba-topic-${++count}`;
      h2.textContent = heading[1].replace(/:\s*$/, '');
      section.setAttribute('aria-labelledby', h2.id);
      section.append(h2);
      sections.append(section);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${h2.id}`;
      link.textContent = h2.textContent;
      item.append(link);
      navList.append(item);
      target = section;
      currentList = parentItem = nestedList = null;
      return;
    }
    const bullet = text.match(/^(\s*)-\s+/);
    if (bullet) {
      let remaining = bullet[0].length;
      const walker = document.createTreeWalker(fragment, NodeFilter.SHOW_TEXT);
      while (remaining) {
        const node = walker.nextNode();
        if (!node) break;
        const remove = Math.min(remaining, node.textContent.length);
        node.textContent = node.textContent.slice(remove);
        remaining -= remove;
      }
      if (!currentList) {
        currentList = document.createElement('ul');
        target.append(currentList);
      }
      const item = document.createElement('li');
      item.append(fragment);
      if (bullet[1].length > 1 && parentItem) {
        if (!nestedList) { nestedList = document.createElement('ul'); parentItem.append(nestedList); }
        nestedList.append(item);
      } else {
        currentList.append(item);
        parentItem = item;
        nestedList = null;
      }
    } else {
      const p = document.createElement('p');
      p.append(fragment);
      target.append(p);
      currentList = parentItem = nestedList = null;
    }
  });
  // Convert only text nodes; retain original links and never interpret text as HTML.
  const walker = document.createTreeWalker(sections, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    if (!node.textContent.includes('**')) return;
    const parts = node.textContent.split(/\*\*([^*]+)\*\*/g);
    const replacement = document.createDocumentFragment();
    parts.forEach((part, i) => {
      if (i % 2) { const strong = document.createElement('strong'); strong.textContent = part; replacement.append(strong); }
      else replacement.append(document.createTextNode(part));
    });
    node.replaceWith(replacement);
  });
  // Leave the original page intact if its format changes or content would be lost.
  if (normalize(intro.textContent + sections.textContent) !== originalText) return;
  const retainedLinks = [...intro.querySelectorAll('a'), ...sections.querySelectorAll('a')].map(a => a.href);
  if (JSON.stringify(originalLinks) !== JSON.stringify(retainedLinks)) return;
  layout.append(nav, sections);
  root.append(intro, layout);
  content.replaceChildren(root);
  content.dataset.monolithAccessible = 'true';
  document.body.classList.add('monolith-accessibility-page');
})();
